import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

const Settings = () => {

  const [passwords, setPasswords] = useState({
    current: "",
    new: "",
    confirm: "",
  });
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const [formData, setFormData] = useState({
    complexName: '',
    ownerName: '',
    email: '',
    phone: '',
    location: ''
  });

  const togglePassword = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handlePasswordChange = (field, value) => {
    setPasswords((prev) => ({ ...prev, [field]: value }));
  };

  const handleFormChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  const handleAccountSubmit = (e) => {
    e.preventDefault();
    alert('Account settings saved successfully!');
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwords.new !== passwords.confirm) {
      alert('New password and confirm password do not match!');
      return;
    }
    alert('Password changed successfully!');
    setPasswords({ current: '', new: '', confirm: '' });
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      alert(`Logo "${file.name}" selected for upload`);
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="page-content">
          <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
            <div className="breadcrumb-title pe-3">Settings</div>
            <div className="ps-3">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Settings</li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="main-body setting_page">
            <div className="row">
              {/* Tabs */}
              <ul className="nav nav-tabs" id="settingsTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="account-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#account"
                    type="button"
                    role="tab"
                  >
                    Account Settings
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="security-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#security"
                    type="button"
                    role="tab"
                  >
                    Security & Login
                  </button>
                </li>
              </ul>
              <div className="tab-content mt-3" id="settingsTabContent">
                <div className="tab-pane fade show active" id="account" role="tabpanel">
                  <div className="card settings-card p-4 p-md-5">
                    <h4 className="mb-4 fw-semibold">Complex Information</h4>
                    <form id="accountForm" onSubmit={handleAccountSubmit}>
                      {/* Logo Section */}
                      <div className="align-items-center gap-4 mb-4 flex-wrap">
                        <div className="logo-box">
                          <span>SC</span>
                        </div>
                        <div className="mt-4">
                          <label htmlFor="logoUpload" className="change-logo-btn" style={{ cursor: 'pointer' }}>Change Logo</label>
                          <input type="file" id="logoUpload" hidden onChange={handleLogoChange} />
                        </div>
                      </div>
                      {/* Bootstrap Grid */}
                      <div className="row g-4">
                        <div className="col-md-6">
                          <label className="form-label">Complex Name</label>
                          <input 
                            type="text" 
                            className="form-control custom-input" 
                            id="complexName"
                            placeholder="City Sporting Complex" 
                            value={formData.complexName}
                            onChange={handleFormChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Owner Name</label>
                          <input 
                            type="text" 
                            className="form-control custom-input" 
                            id="ownerName"
                            placeholder="John Davis" 
                            value={formData.ownerName}
                            onChange={handleFormChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Email Address</label>
                          <input 
                            type="email" 
                            className="form-control custom-input" 
                            id="email"
                            placeholder="john@complex.com" 
                            value={formData.email}
                            onChange={handleFormChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Phone Number</label>
                          <input 
                            type="text" 
                            className="form-control custom-input" 
                            id="phone"
                            placeholder="+1 555 0001" 
                            value={formData.phone}
                            onChange={handleFormChange}
                          />
                        </div>
                        <div className="col-12">
                          <label className="form-label">Location</label>
                          <input 
                            type="text" 
                            className="form-control custom-input" 
                            id="location"
                            placeholder="Downtown Sports District, New York, NY" 
                            value={formData.location}
                            onChange={handleFormChange}
                          />
                        </div>
                      </div>
                      <button type="submit" className="btn save-btn mt-4 px-4">
                        Save Changes
                      </button>
                    </form>
                  </div>
                </div>

                <div className="tab-pane fade" id="security" role="tabpanel">
                  <form id="securityForm" onSubmit={handlePasswordSubmit}>
                    <div className="mb-3 position-relative">
                      <label htmlFor="currentPassword" className="form-label">Current Password</label>
                      <input 
                        type={showPassword.current ? "text" : "password"} 
                        id="currentPassword" 
                        className="form-control password-input" 
                        required 
                        value={passwords.current}
                        onChange={(e) => handlePasswordChange('current', e.target.value)}
                      />
                      <span 
                        className="toggle-password" 
                        style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                        onClick={() => togglePassword('current')}
                      >
                        <i className={showPassword.current ? "bx bx-show" : "bx bx-hide"} />
                      </span>
                    </div>
                    <div className="mb-3 position-relative">
                      <label htmlFor="newPassword" className="form-label">New Password</label>
                      <input 
                        type={showPassword.new ? "text" : "password"} 
                        id="newPassword" 
                        className="form-control password-input" 
                        required 
                        value={passwords.new}
                        onChange={(e) => handlePasswordChange('new', e.target.value)}
                      />
                      <span 
                        className="toggle-password" 
                        style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                        onClick={() => togglePassword('new')}
                      >
                        <i className={showPassword.new ? "bx bx-show" : "bx bx-hide"} />
                      </span>
                    </div>
                    <div className="mb-3 position-relative">
                      <label htmlFor="confirmPassword" className="form-label">Confirm New Password</label>
                      <input 
                        type={showPassword.confirm ? "text" : "password"} 
                        id="confirmPassword" 
                        className="form-control password-input" 
                        required 
                        value={passwords.confirm}
                        onChange={(e) => handlePasswordChange('confirm', e.target.value)}
                      />
                      <span 
                        className="toggle-password" 
                        style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                        onClick={() => togglePassword('confirm')}
                      >
                        <i className={showPassword.confirm ? "bx bx-show" : "bx bx-hide"} />
                      </span>
                    </div>
                    <button type="submit" className="btn btn-primary btn-sm px-4">Change Password</button>
                  </form>
                </div>
              </div>
              {/* End Tab Content */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Settings